import { request } from "./request";

export function listProjectsWithDevices() {
  return request("/device/listProjectsWithDevices", {
    method: "GET",
  });
}

export function listAllDevices() {
  return request("/device/listAllDevices", {
    method: "GET",
  });
}

export function addProjects(data) {
  return request("/device/addProjects", {
    method: "POST",
    body: {
      code: data.code,
      name: data.name,
      serviceDescribe: data.serviceDescribe ?? data.describe,
      duration: data.duration,
      deviceIds: (data.deviceIds || []).map((id) => String(id)),
      repairIds: (data.repairIds || []).map((id) => String(id)),
    },
  });
}

export function getProject(data) {
  return request("/device/getProject", {
    method: "POST",
    body: {
      projectId: String(data.projectId),
    },
  });
}


export function updateProject(data) {
  return request("/device/updateProject", {
    method: "POST",
    body: {
      id: String(data.id),
      code: data.code,
      name: data.name,
      duration: data.duration,
      serviceDescribe: data.serviceDescribe ?? data.describe,
      checkedDevices: (data.checkedDevices || []).map((d) => ({
        deviceId: String(d.deviceId),
        deviceName: d.deviceName,
      })),
      repairIds: (data.repairIds || []).map((id) => String(id)),
    },
  });
}

export function addDevices(data) {
  return request("/device/addDevices", {
    method: "POST",
    body: {
      deviceName: data.deviceName,
    },
  });
}

export function saveCheckedDevices(data) {
  return request("/device/saveCheckedDevices", {
    method: "POST",
    body: {
      projectId: String(data.projectId),
      deviceIds: data.deviceIds || [],
    },
  });
}

export function deleteProject(data) {
  return request("/device/deleteProject", {
    method: "POST",
    body: {
      projectId: String(data.projectId),
    },
  });
}

export function updateDevice(data) {
  return request("/device/updateDevice", {
    method: "POST",
    body: {
      deviceId: String(data.deviceId),
      deviceName: data.deviceName,
    },
  });
}


export function deleteDevice(data) {
  return request("/device/deleteDevice", {
    method: "POST",
    body: {
      deviceId: String(data.deviceId),
    },
  });
}
